<template>
	<v-menu
		bottom
		min-width="300"
		:position-x="left"
		:position-y="bottom"
		v-model="showMenu"
	>
		<v-list>
			<template v-for="(user, i) in users">
				<v-list-item
					v-if="i < 5"
					class="font-14 font-weight-medium text-start px-3 rounded-0 cursor-pointer d-flex align-center"
					:key="'mention-user-' + i"
					@click="addMention(user)"
					@mouseenter="setActive(i)"
					:class="{ 'primary--text accent lighten-2' : active === i, 'grey--text text--darken-2' : active !== i }"
				>
					<avatar :user="user" sm class="mr-2"/>
					{{ user.name }}
				</v-list-item>
			</template>
		</v-list>
	</v-menu>
</template>

<script>
import Avatar from "@/components/Avatar";
import {mapGetters} from 'vuex';

export default {
	name: "ContentEditableMentions",
	components: {
		Avatar
	},
	props: {
		chatRoomUsers: {
			type: Array,
			required: false
		},
		attach: {
			type: String
		},
		mention: {
			type: Object,
			default: null
		},
		addMention: {
			type: Function,
			required: true
		},
		clearMention: {
			type: Function,
			required: true
		}
	},
	data () {
		return {
			users: null,
			active: null,
			showMenu: false,
			left: null,
			bottom: null,
			enabledSearch: true
		}
	},
	watch: {
		mention(v) {
			if (v && v.text) {
				this.getUsers(v)
				this.left = v.caret.coordinates.left
				this.bottom = v.caret.coordinates.bottom + 5
			} else {
				this.users = null
				this.showMenu = false
				this.destroyListListeners()
			}
		}
	},
	destroyed() {
		this.destroyListListeners()
	},
	computed: {
		...mapGetters({
			user: 'auth/user'
		})
	},
	methods: {
		listListenersHandler(e) {
			if (e.key === 'Enter' && this.users[this.active])
				this.addMention(this.users[this.active])
			if (e.key === 'Escape')
				this.users = null
		},
		createListListeners() {
			window.addEventListener('keydown', this.listListenersHandler)
		},
		destroyListListeners() {
			window.removeEventListener('keydown', this.listListenersHandler)
		},
		goUp() {
			if (this.active > -1)
				this.active--
		},
		goDown() {
			if (this.active + 1 < this.users.length)
				this.active++
		},
		setActive(i) {
			this.active = i
		},
		searchRoomUsers(text) {
			console.log("ALL USERS", this.chatRoomUsers)
			const users = this.chatRoomUsers.filter((str)=>{
				return str.name.toLowerCase().indexOf(text.toLowerCase()) >= 0 && str.id != this.user.id;
			});

			console.log("SEARCH ROOM USERS", users)


			this.users = users;
			this.active = -1;
			this.showMenu = this.users.length > 0 && this.mention
			this.createListListeners();
		},
		async getUsers(v) {
			if (this.enabledSearch) {
				if(this.chatRoomUsers) {
					this.searchRoomUsers(v.text);
				}
				else {
					this.$axios
						.get('users/company', {
							params: {
								name: v.text
							}
						})
						.then(response => {
							this.users = response.data.data
							this.active = -1
							this.showMenu = this.users.length > 0 && this.mention
							this.createListListeners()
						})
						.catch(e => {
							console.log("GET USER MENTIONS ERROR", e)
						})
				}

			}

		}
	}
}
</script>

<style lang="scss">

</style>
